module.exports = __webpack_public_path__ + "img/LMI_GoToConnect_Green_HEX.9ca92849.png";